import $ from "jquery";
import axios from "axios";

const changeLanguageUrl = '/help/rest/change-language';

$(() => {
    $('#language-selector').on('change2', e => {
        const language = $(e.target).val();

        const data = new FormData();
        data.append('language', language);

        axios.post(
            changeLanguageUrl,
            data,
            { headers: {'Content-Type': 'application/x-www-form-urlencoded'} },
        )
            .then(() => {
                window.location.reload();
            })
            .catch(error => {
                console.log(error);
            });
    });
});
